import styled from '../utils/styled-components-wrapper.js'

export const ContentThemeOnlyDark = styled.div`
  display: var(--lido-color-darkDisplay, contents);
`

export const ContentThemeOnlyLight = styled.div`
  display: var(--lido-color-lightDisplay, contents);
`
